var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.002,
    height: 102.003,
    viewBox: "0 0 90.002 102.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M460.77,308.258,447.211,295.12l8.452-8.452,6.073,5.884,4.133-4.133a2.981,2.981,0,0,0,0-4.223l-3.606-3.611a56.482,56.482,0,0,1,4.813-3.64l3.02,3.022a8.957,8.957,0,0,1,0,12.676l-4.066,4.065,3.19,3.091a5.977,5.977,0,0,1-8.449,8.457ZM426.078,295.12l-8.453-8.451a8.964,8.964,0,0,1,0-12.68L432.419,259.2l21.132,21.13L438.759,295.12a8.965,8.965,0,0,1-12.681,0Zm8.455-21.128-4.226,4.225a2.988,2.988,0,1,0,4.226,4.226l4.226-4.226a2.988,2.988,0,1,0-4.226-4.225Zm1.856-19.276a64.25,64.25,0,0,0,14.17-28.7l.3-1.5L488.1,261.753l-1.5.3a64.03,64.03,0,0,0-28.561,14.307ZM493.6,258.8l-39.792-39.785a5.98,5.98,0,1,1,8.458-8.455l39.785,39.788A5.976,5.976,0,0,1,493.6,258.8Zm2.434-20.919a2.988,2.988,0,0,1,0-5.977h5.978a2.988,2.988,0,0,1,0,5.977Zm-8.09-12.829a2.988,2.988,0,0,1,0-4.226l5.977-5.977a2.989,2.989,0,0,1,4.226,4.226l-5.977,5.977a2.988,2.988,0,0,1-4.226,0ZM475.11,216.96V210.99a2.99,2.99,0,1,1,5.98,0v5.971a2.99,2.99,0,1,1-5.98,0Z",
    transform: "translate(-414.998 -208)",
    fill: "#dde8f9",
    opacity: 0.302
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosed);
export default __webpack_public_path__ + "static/media/closed.16f6ddfb0b1bc6872e5bef31968d5075.svg";
export { ForwardRef as ReactComponent };